import moment from 'moment';

export function formatIsoDate(date) {
  if (date) return moment(date).format('YYYY-MM-DD');
  return date;
}

export function formatIsoDateTime(datetime) {
  if (datetime) return moment(datetime).format('YYYY-MM-DDTHH:mm:ssZZ');
  return datetime;
}

export function datetimeReadable(datetime) {
  if (datetime) return moment(datetime).utc().format('MMM Do YYYY, h:mm:ss A');
  return datetime;
}

export function now() {
  return moment.utc();
}

export function formatIsoDateUnix(date) {
  if (date) return moment.unix(date).format('YYYY-MM-DD');
  return date;
}



// WEBPACK FOOTER //
// ./utils/dates.js